import axios from "axios";
import Common from "../../componets/Common";

export const registrarObtenerPagoPowerpay = async (status, transaccionId) => {

  try {
    const url = `${Common.urlAPI}/ConfirmarPagoPowerpay/${status}/${transaccionId}`;    

    const resp = await axios.post( url );

    return {
      ...resp.data,
      mensajeError: ""
    }

  } catch (err) {
    console.log('error', err);
    const mensajeError = err.response && err.response.status === 401 ? err.response.data.message : err.toString();
    return {
      mensajeError      
    }
  }
}
